import React from 'react';

const { version, repository } = require('../../package.json');

function VersionDisplay() {
  return (
    <a
      href={repository.url}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: '12px',
        left: '12px',
        fontSize: '11px',
        color: '#666',
        fontFamily: 'monospace',
        zIndex: 1000,
        userSelect: 'none',
        textDecoration: 'none',
      }}
      title="View on GitHub"
    >
      v
      {version}
    </a>
  );
}

export default VersionDisplay;
